export const ADD_INVOICE_CODE_2_TRANSACTION = {
    REQUEST: 'ADD_INVOICE_CODE_2_TRANSACTION_REQUEST',
    SUCCESS: 'ADD_INVOICE_CODE_2_TRANSACTION_SUCCESS',
    FAILED: 'ADD_INVOICE_CODE_2_TRANSACTION_FAILED',
};

export const CLEAR_ADD_INVOICE_CODE_2_TRANSACTION = 'CLEAR_ADD_INVOICE_CODE_2_TRANSACTION';
